"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePatientProgressContentFailure = exports.updatePatientProgressSectionFailure = exports.updatePatientProgressContentSuccess = exports.updatePatientProgressSectionSuccess = exports.updatePatientProgressContentRequest = exports.updatePatientProgressSectionRequest = exports.deleteUserFailure = exports.deleteUserSuccess = exports.updateUserSuccess = exports.createUserSuccess = exports.listCaregiversRequest = exports.bulkUsersFailure = exports.bulkUsersSuccess = exports.bulkUsersRequest = exports.listUsersRequest = exports.createPasswordSuccess = exports.resetPasswordChangeSuccess = exports.resetPasswordSuccess = exports.startup = exports.logout = exports.setCreateUser = exports.authSuccess = exports.setUserSession = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const effects_1 = require("redux-saga/effects");
const toast_1 = require("@/components/toast");
const constants_1 = __importStar(require("@/constants"));
const ApiService_1 = __importDefault(require("@/helpers/ApiService"));
const auth_1 = require("@/helpers/auth");
const history_1 = __importDefault(require("@/helpers/history"));
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const user_1 = require("@/redux/user");
const types_1 = require("@/screens/manage-accounts/types");
const selectors_1 = __importDefault(require("@/selectors"));
function* setUserSession({ payload }) {
    const { user } = payload.data;
    yield effects_1.put({ type: user_1.ACTIONS.STORE_USER, payload: { user } });
    yield effects_1.call(auth_1.setAuth, user.token);
    yield effects_1.call(ApiService_1.default.setAuthHeader, user.token);
    const storedUser = (yield effects_1.select(selectors_1.default.user.getUser));
    if (!storedUser.isActive) {
        yield effects_1.call(toast_1.showToast, constants_1.default.general.inactiveAccount, constants_1.default.general.inactiveAccountDescription);
        yield effects_1.call(history_1.default.push, constants_1.Routes.Login);
    }
    if (storedUser.isValid) {
        const { programs } = storedUser;
        if (programs.length) {
            yield effects_1.put(radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.getProgramPayload(programs[0])));
            yield effects_1.put(radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.getSectionsPayload({ id: programs[0] })));
        }
    }
}
exports.setUserSession = setUserSession;
function* authSuccess(action) {
    yield setUserSession(action);
    yield effects_1.call(history_1.default.push, constants_1.Routes.Home);
}
exports.authSuccess = authSuccess;
function* setCreateUser() {
    yield effects_1.call(history_1.default.push, constants_1.Routes.VerifyEmail);
}
exports.setCreateUser = setCreateUser;
function* logout() {
    yield effects_1.call(auth_1.deleteAuth);
    yield effects_1.call(history_1.default.push, constants_1.Routes.Login);
}
exports.logout = logout;
function* startup() {
    const token = auth_1.getAuth();
    if (token) {
        yield effects_1.call(ApiService_1.default.setAuthHeader, token);
        yield effects_1.put(redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.hydrateUserPayload()));
    }
}
exports.startup = startup;
function* resetPasswordSuccess() {
    yield effects_1.call(history_1.default.push, constants_1.Routes.ResetPasswordInstructions);
}
exports.resetPasswordSuccess = resetPasswordSuccess;
function* resetPasswordChangeSuccess() {
    yield effects_1.call(toast_1.showToast, constants_1.default.changePassword.passwordCreated, constants_1.default.changePassword.youCanLogin);
    yield effects_1.call(history_1.default.push, constants_1.Routes.Login);
}
exports.resetPasswordChangeSuccess = resetPasswordChangeSuccess;
function* createPasswordSuccess() {
    yield effects_1.call(toast_1.showToast, constants_1.default.passwordCreation.passwordCreated, constants_1.default.passwordCreation.youCanLogin);
    yield effects_1.call(history_1.default.push, constants_1.Routes.Login);
}
exports.createPasswordSuccess = createPasswordSuccess;
function* listUsersRequest({ payload, }) {
    yield effects_1.put(redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.listUsersPayload(payload)));
}
exports.listUsersRequest = listUsersRequest;
function* bulkUsersRequest({ payload, }) {
    yield effects_1.put(redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.bulkUsersPayload(payload)));
}
exports.bulkUsersRequest = bulkUsersRequest;
function* bulkUsersSuccess({ payload, }) {
    const { accounts, status, bulk_type } = payload === null || payload === void 0 ? void 0 : payload.data;
    if (bulk_type === types_1.BulkTypes.STATUS) {
        yield effects_1.call(toast_1.showToast, '', constants_1.default.manageAccounts.youMarkedStatus(accounts.length, status));
    }
    if (bulk_type === types_1.BulkTypes.INVITE) {
        yield effects_1.call(toast_1.showToast, '', constants_1.default.manageAccounts.invitesSuccess);
    }
}
exports.bulkUsersSuccess = bulkUsersSuccess;
exports.default = { setUserSession };
function* bulkUsersFailure({ payload, }) {
    const { statusCode } = payload;
    yield effects_1.call(toast_1.showToast, `Error ${statusCode}`, constants_1.default.general.thereWasAnError);
}
exports.bulkUsersFailure = bulkUsersFailure;
function* listCaregiversRequest() {
    yield effects_1.put(redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.listCaregiversPayload()));
}
exports.listCaregiversRequest = listCaregiversRequest;
function* createUserSuccess(data) {
    var _a;
    const { firstName, lastName } = (_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a.meta;
    yield effects_1.call(toast_1.showToast, '', constants_1.default.manageAccounts.create.successfullyAdded(`${firstName} ${lastName}`));
    yield effects_1.call(history_1.default.push, constants_1.Routes.ManageAccounts);
}
exports.createUserSuccess = createUserSuccess;
function* updateUserSuccess(data) {
    var _a;
    const { firstName, lastName } = (_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a.meta;
    yield effects_1.call(toast_1.showToast, '', constants_1.default.manageAccounts.detail.successfullyUpdated(`${firstName} ${lastName}`));
}
exports.updateUserSuccess = updateUserSuccess;
function* deleteUserSuccess(data) {
    var _a;
    const { userFullName } = (_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a.meta;
    yield effects_1.call(toast_1.showToast, '', constants_1.default.manageAccounts.detail.successfullyDeleted(userFullName));
    yield effects_1.call(history_1.default.push, constants_1.Routes.ManageAccounts);
}
exports.deleteUserSuccess = deleteUserSuccess;
function* deleteUserFailure(action) {
    const { statusCode } = action === null || action === void 0 ? void 0 : action.payload;
    yield effects_1.call(toast_1.showToast, `Error ${statusCode}`, constants_1.default.general.thereWasAnError);
}
exports.deleteUserFailure = deleteUserFailure;
function* updatePatientProgressSectionRequest({ payload, }) {
    yield effects_1.put(redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.updatePatientProgressSectionPayload(payload)));
    yield effects_1.call(toast_1.showLoaderToast);
}
exports.updatePatientProgressSectionRequest = updatePatientProgressSectionRequest;
function* updatePatientProgressContentRequest({ payload, }) {
    yield effects_1.put(redux_1.ActionCreators.api.makeRequest.dispatch(api_payloads_1.updatePatientProgressContentPayload(payload)));
    yield effects_1.call(toast_1.showLoaderToast);
}
exports.updatePatientProgressContentRequest = updatePatientProgressContentRequest;
function* updatePatientProgressSectionSuccess() {
    yield effects_1.call(react_hot_toast_1.default.dismiss);
    yield effects_1.call(toast_1.showToast, '', constants_1.default.patientProgress.detail.sectionUpdated);
}
exports.updatePatientProgressSectionSuccess = updatePatientProgressSectionSuccess;
function* updatePatientProgressContentSuccess() {
    yield effects_1.call(react_hot_toast_1.default.dismiss);
    yield effects_1.call(toast_1.showToast, '', constants_1.default.patientProgress.detail.contentUpdated);
}
exports.updatePatientProgressContentSuccess = updatePatientProgressContentSuccess;
function* updatePatientProgressSectionFailure() {
    yield effects_1.call(react_hot_toast_1.default.dismiss);
}
exports.updatePatientProgressSectionFailure = updatePatientProgressSectionFailure;
function* updatePatientProgressContentFailure() {
    yield effects_1.call(react_hot_toast_1.default.dismiss);
}
exports.updatePatientProgressContentFailure = updatePatientProgressContentFailure;
